import React from 'react';
import {useField} from 'formik';
import classnames from 'classnames';
import {omit} from 'lodash';

import Checkbox, {Props as CheckboxProps} from 'shared/components/checkbox';
import Fieldset from 'shared/components/fieldset';

interface FormikCheckboxesProps {
  name: string;
  label?: string;
  options: ({value: string; label: string} & CheckboxProps)[] | string[];
  required?: boolean;
  className?: string;
}

const FormikCheckboxes = ({
  name,
  options,
  label,
  required = true,
  className,
}: FormikCheckboxesProps) => {
  const [field, meta, helpers] = useField(name);

  return (
    <Fieldset className={classnames('checkboxes', className, {'mt-0': !label})}>
      {label && (
        <Fieldset.Legend className="shared-checkboxes-legend" required={required}>
          {label}
        </Fieldset.Legend>
      )}
      {options.map((option, index) => {
        const optionLabel = typeof option === 'string' ? option : option.label;
        const value = typeof option === 'string' ? option : option.value;

        return (
          <Checkbox
            key={index}
            name={name}
            value={value}
            label={optionLabel}
            checked={field.value.includes(value)}
            onChange={(e) => {
              if (e.target.checked) {
                helpers.setValue([...field.value, value]);
              } else {
                helpers.setValue(field.value.filter((item) => item !== value));
              }
            }}
            error={!!(meta.touched && meta.error)}
            {...(typeof option !== 'string' && omit(option, ['label', 'value']))}
          />
        );
      })}

      {meta.touched && meta.error && (
        <p className="shared-error-text" role="alert">
          {meta.error}
        </p>
      )}
    </Fieldset>
  );
};

export default FormikCheckboxes;
